import { Component, OnInit } from '@angular/core';
import { Context } from '../../Services/context.service';
import { Title } from '@angular/platform-browser';


@Component({
  selector: 'main-component',
  templateUrl: './main.component.html'
})

export class MainComponent implements OnInit {





  constructor(
      public context: Context,
      private title: Title,
  ) { }

   public ShopName: string=''
    ngOnInit(): void {
      //if (this.context.settings.IsAuthenticated == false) {return}
        
      //  if (this.ShopName == '') {
      //    this.context.api.ShopInfo().then(shopInfo => {
      //        this.ShopName = shopInfo.Name
      //        this.title.setTitle(this.ShopName + ' - Administration' )
      //    })
      //}
  }
}


